function getEmptyGj() {
  return {
    type: "FeatureCollection",
    features: [],
  };
}

function sortLayers(campGeojson) {
  //if (!Array.isArray(campGeojson?.features)) return {};
  let result = {
    fill: getEmptyGj(),
    extrusion: getEmptyGj(),
    line: getEmptyGj(),
    point: getEmptyGj(),
    poi: getEmptyGj(),
  };
  campGeojson.features.forEach((feature) => {
    if (["MultiLineString", "LineString"].includes(feature.geometry.type))
      return result.line.features.push(feature);
    if (["Point"].includes(feature.geometry.type))
      return result.point.features.push(feature);
    if (feature.properties.height)
      return result.extrusion.features.push(feature);
    return result.fill.features.push(feature);
  });
  return result;
}

function matchColorsWithIDs(geojson, CLASS_COLORS) {
  //TODO remove this method once generating geojson is done on backend
  const colors = {};

  geojson.features.forEach(feature => {
    const featureClass = feature.properties.class;
    if (featureClass in CLASS_COLORS) {
      colors[featureClass] = CLASS_COLORS[featureClass];
    }
  });
  return colors;
}

/*function matchColorsWithIDs(geojson, CLASS_COLORS) {
  const colors = {};

  geojson.features.forEach(feature => {
    const id = feature.properties.id;
    const featureClass = feature.properties.class;

    if (id !== undefined && featureClass in CLASS_COLORS) {
      colors[id] = CLASS_COLORS[featureClass];
    }
  });
  return colors;
}*/

export default {
  sortLayers,
  getEmptyGj,
  matchColorsWithIDs
}
